module.exports = __webpack_public_path__ + "static/media/hotspot-tooltip-info.867c8c63.svg";